// Note: This file is used to store shared CSS pieces
// that can be used across styled-components.

export const styledDropdownScrollbar = () => `
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 4px;
    border-radius: 4px;
    background: #e4e4e4;
  }
`
